import { marker as T } from '@biesbjerg/ngx-translate-extract-marker';

export default {
  help: T('Looking for help?'),

  docsA: T('The'),
  docsB: T('TrueNAS Documentation Site'),
  docsC: T('is a collaborative website \
    with helpful guides and information about your new storage system.'),

  forumsA: T('The'),
  forumsB: T('TrueNAS Community Forums'),
  forumsC: T('are the best place to ask questions and interact with fellow TrueNAS'),
  forumsD: T('users'),

  newsLetterA: T('You can join the '),
  newsLetterB: T('TrueNAS Newsletter'),
  newsLetterC: T(' for monthly updates and latest developments.'),

  contactA: T('Does your business need'),
  contactB: T('Enterprise level'),
  contactC: T('support and services? Contact'),
  contactD: T('iXsystems for more information.'),

  opensourceA: T('is Free and'),
  opensourceB: T('Open Source'),
  opensourceC: T('software, which is provided as-is with no warranty.'),

  findagainA: T('Find this information later by clicking'),
  findagainB: T('(top-right), then'),
  findagainC: T('About.'),

  actionBtnText: {
    splash: T('Get Started'),
    about: T('Close'),
  },
};
